import { useCallback, memo } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import UserAvatar from '../../userAvatar';
import CustomCheckbox from '../../customCheckbox';

const useStyles = makeStyles(({ palette: { primary }, spacing }) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  checkbox: {
    marginRight: spacing(2),
  },
  avatar: {
    maxWidth: 'calc(100% - 40px)',
  },
  userLabel: {
    color: primary.bluish1,
    fontFamily: 'ProximaNova-Bold',
    fontSize: 16,
    lineHeight: '20px',
  },
}));

const User = ({ user, isSelected, onChange }) => {
  const classes = useStyles();

  const handleChange = useCallback(
    () => onChange(user.id),
    [user.id, onChange]
  );

  return (
    <div className={classes.root}>
      <CustomCheckbox
        customRootClass={classes.checkbox}
        isChecked={isSelected}
        onChange={handleChange}
      />

      <UserAvatar
        className={classes.avatar}
        labelClass={classes.userLabel}
        user={user}
        onClickHandler={handleChange}
        clickableCaption
        caption
        small
      />
    </div>
  );
};

User.propTypes = {
  user: PropTypes.object.isRequired,
  isSelected: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default memo(User);
